import React from 'react';
import { connect } from 'react-redux';
import { ICustomer } from '../../../data/entities/customer';
import { IEventV2 } from '../../../data/entities/event';
import { IProperty } from '../../../data/entities/property';
import { createEventNotes } from '../../../entities/event-notes/actions';
import { IThunkDispatch } from '../../../store/middleware';
import { CustomerServiceEmailsComponent } from './CustomerServiceEmails';
import { IEmailTemplateInfo } from './emailTemplates';

export interface ICustomerServiceEmailsProps {
	event: IEventV2;
	customer: ICustomer;
	property: IProperty;
	onSendComplete: (success: boolean, templateId: string, templateInfo: IEmailTemplateInfo, event: IEventV2) => void;
}

const buildEventString = (context: object, text: string) => {
	const stringContext = Object.keys(context).map((key) => `${key}=${context[key]}`).join('|');
	return `[Event|${stringContext}] ${text}`;
};

const mapDispatchToProps = (dispatch: IThunkDispatch) => ({
	onSendComplete: (success: boolean, templateId: string, templateInfo: IEmailTemplateInfo, event: IEventV2) => {
		if (success) {
			const eventString = buildEventString({
				type: 'Email Sent',
				templateId,
				date: new Date().toISOString(),
				...templateInfo?.options
			}, `Sent ${templateInfo.name} to ${templateInfo.target}`);

			dispatch(createEventNotes(event.property_id, event.id, [
				{
					event_id: event.id,
					note_type: 'email event',
					content: eventString
				}
			]));
		}
	}
});

const CustomerServiceEmailsContainer: React.FC<ICustomerServiceEmailsProps> = (props) => {
	return <CustomerServiceEmailsComponent
		event={props.event}
		customer={props.customer}
		property={props.property}
		onSendComplete={props.onSendComplete}
	/>;
};

export const CustomerServiceEmails = connect(null, mapDispatchToProps)(CustomerServiceEmailsContainer);
